var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var cookies = require('doc-cookies');

var aagc, typeSelector, cats, captionText, filterBtn;
var OPEN_CLASS = 'open';
var ICON_PLUS_CIRCLE = 'icon-plus-circle2';
var ICON_MINUS_CIRCLE = 'icon-minus-circle2';

var initDom = function() {
    aagc = document.querySelector('.at-a-glance-carousel-wrapper');
    if (aagc) {
        typeSelector = aagc.querySelector('.image-type-selector');
        cats = aagc.querySelector('.categories');
        captionText = aagc.querySelector('.caption-text');
        filterBtn = typeSelector.querySelector('.filter-btn');
    }
};

var changeFilterBtnClass = function() {
    var web503 = ($('.image-type-selector').data('abtest') === 'web-503');
    if(!web503) {

        if (typeSelector.classList.contains(OPEN_CLASS)) {
            filterBtn.classList.remove(ICON_PLUS_CIRCLE);
            filterBtn.classList.add(ICON_MINUS_CIRCLE);
        } else {
            filterBtn.classList.remove(ICON_MINUS_CIRCLE);
            filterBtn.classList.add(ICON_PLUS_CIRCLE);
        }
    } else {
        var filterBtnIcon = typeSelector.querySelector('.filter-btn .icon');
        var filterBtnText = typeSelector.querySelector('.filter-btn .filter-text');

        if (typeSelector.classList.contains(OPEN_CLASS)) {
            filterBtnIcon.classList.add('icon-cross2');
            filterBtnText.innerHTML = 'close';
        } else {
            filterBtnIcon.classList.remove('icon-cross2');
            filterBtnText.innerHTML = 'filter';
        }
    }
};

var _toggleFilter = function(isButtonClick, isOpened) {
    initDom();
    if(isOpened) {
        typeSelector.classList.toggle(OPEN_CLASS, isOpened);
        if(cats) { cats.classList.toggle(OPEN_CLASS, isOpened); }
        captionText.classList.toggle(OPEN_CLASS, isOpened);
    } else {
        // Safari cannot handle situations where second argument to toggle() is undefined; it seems to evaluate to false.
        // We do not want to force a value in all cases; we want toggle() to handle what to do based on existence of passed class.
        typeSelector.classList.toggle(OPEN_CLASS);
        if(cats) { cats.classList.toggle(OPEN_CLASS); }
        captionText.classList.toggle(OPEN_CLASS);
    }
    _fireViewFilter(isButtonClick);
    changeFilterBtnClass();
};

var _closeFilter = function(e) {
    var $parent = $(e.target).parents('.image-type-selector');
    if($parent.length > 0) {
        return;
    }
    initDom();

    if(typeSelector.classList.contains(OPEN_CLASS)) {
        typeSelector.classList.remove(OPEN_CLASS);
    }
    if(cats && cats.classList.contains(OPEN_CLASS)) {
        cats.classList.remove(OPEN_CLASS);
    }
    if(captionText.classList.contains(OPEN_CLASS)) {
        captionText.classList.remove(OPEN_CLASS);
    }
    changeFilterBtnClass();
};

var fireChangeContent = function (cat) {
    var val = cat;
    if(cat === 'all'){
        val = 'home';
    }
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name':'view_content',
            'subaction_name':'view_filter_content',
            'action_cause': 'link_click',
            'creative_id': 'edm-entry-at-a-glance',
            'value':val
        }
    });
};
var fireToggleFilter = function () {
    initDom();
    var subAction = (typeSelector.classList.contains(OPEN_CLASS)) ? 'close_filter_panel' : 'open_filter_panel';
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name': 'view_content',
            'subaction_name': subAction,
            'action_cause': 'button_click',
            'creative_id': 'edm-entry-at-a-glance'
        }
    });
};

var _fireViewFilter = function (isButtonClick) {
    if (typeSelector.classList.contains(OPEN_CLASS)) {
        cookies.setItem('aagFilter','open',null,'/');
        var action = isButtonClick ? 'button_click' : 'page_load';
        eventToolbox.fireAction({
            'event_type': 'action_completed',
            'ads': {
                'disable_refresh': true
            },
            'event_data': {
                'action_category': 'user',
                'action_name': 'view_content',
                'subaction_name': 'view_filter_panel',
                'action_cause': action,
                'creative_id': 'edm-entry-at-a-glance'
            }
        });
    }
};

module.exports = {
    toggleFilter: _toggleFilter,
    closeFilter: _closeFilter,
    fireChangeContent: fireChangeContent,
    fireToggleFilter: fireToggleFilter
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-filter-events.js
// module id = 144
// module chunks = 0 1 27